import { createBrowserRouter } from 'react-router-dom';
import { lazy } from 'react';
import { RUNTIME_CONFIG } from 'runtime-config';

// routes
import AuthenticationRoutes from './AuthenticationRoutes';
import LoginRoutes from './LoginRoutes';
import MainRoutes from './MainRoutes';
import PublicRoutes from './PublicRoutes';
import Loadable from 'ui-component/Loadable';

// 404 page
const NotFound = Loadable(lazy(() => import('views/pages/errors/NotFound')));

// Catch-all 404 route
const NotFoundRoute = {
  path: '*',
  element: <NotFound />
};

// ==============================|| ROUTING RENDER ||============================== //

const router = createBrowserRouter([LoginRoutes, MainRoutes, PublicRoutes, AuthenticationRoutes, NotFoundRoute], {
  basename: RUNTIME_CONFIG.baseName
});

export default router;
